// removed by extract-text-webpack-plugin
module.exports = {"StudentResult--list":"StudentResult--list","StudentResult--list--item":"StudentResult--list--item"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/SearchResult/StudentResult/StudentResult.scss
// module id = 3N7T
// module chunks = 0